export default __webpack_public_path__ + "static/media/resumeActive.9e1920eb.png";